export const PRODUCTS = [
  { value: 'EURUSD', label: 'EUR/USD', pipValue: 10.0 },
  { value: 'GBPUSD', label: 'GBP/USD', pipValue: 10.0 },
  { value: 'USDJPY', label: 'USD/JPY', pipValue: 6.58 },
  { value: 'AUDUSD', label: 'AUD/USD', pipValue: 10.0 },
  { value: 'USDCAD', label: 'USD/CAD', pipValue: 7.35 },
  { value: 'XAUUSD', label: 'XAU/USD', pipValue: 10.0 },
  { value: 'EURJPY', label: 'EUR/JPY', pipValue: 6.58 },
  { value: 'EURGBP', label: 'EUR/GBP', pipValue: 12.66 },
];

export const CURRENCIES = [
  { value: 'USD', label: 'USD', rate: 1 },
  { value: 'EUR', label: 'EUR', rate: 0.92 },
  { value: 'GBP', label: 'GBP', rate: 0.79 },
  { value: 'JPY', label: 'JPY', rate: 151 },
  { value: 'VND', label: 'VND', rate: 25300 },
];

export const RISK_QUICK = [0.5, 1, 2, 3];

export const SL_QUICK = [20, 30, 50, 100];

export const RISK_VARIATIONS = [
  { risk: 0.5, amount: 50, lot: 0.1 },
  { risk: 1, amount: 100, lot: 0.2 },
  { risk: 2, amount: 200, lot: 0.4 },
  { risk: 3, amount: 300, lot: 0.6 },
];

export const MISTAKES = [
  {
    icon: 'ri-wallet-3-line',
    title: 'Chỉ dựa vào số dư tài khoản',
    desc: 'Chỉ nhìn vào số dư để chọn khối lượng mà không xét đến Stop Loss và tỷ lệ rủi ro khiến vị thế dễ bị quá lớn hoặc quá nhỏ.',
  },
  {
    icon: 'ri-error-warning-line',
    title: 'Bỏ qua Stop Loss',
    desc: 'Khoảng cách Stop Loss khác nhau sẽ cho khối lượng khác nhau. Cùng một mức rủi ro, Stop Loss càng xa thì số lot càng phải nhỏ.',
  },
  {
    icon: 'ri-calculator-line',
    title: 'Không tính giá trị Pip',
    desc: 'Giá trị Pip của từng sản phẩm là khác nhau. USD/JPY và XAU/USD không giống EUR/USD, tính sai Pip sẽ làm sai toàn bộ khối lượng.',
  },
  {
    icon: 'ri-scales-3-line',
    title: 'Chỉ nhìn vào đòn bẩy',
    desc: 'Đòn bẩy ảnh hưởng đến yêu cầu ký quỹ, nhưng không thể dùng riêng nó để quyết định mức rủi ro cho một giao dịch.',
  },
];

export const RELATED_TOOLS = [
  {
    icon: 'ri-bank-line',
    title: 'Máy tính Ký quỹ',
    desc: 'Tính số tiền ký quỹ cần thiết cho một giao dịch.',
    to: '/may-tinh-ky-quy',
    accent: '#7C3AED',
  },
  {
    icon: 'ri-line-chart-line',
    title: 'Máy tính Lợi nhuận & Thua lỗ',
    desc: 'Tính lợi nhuận hoặc thua lỗ dự kiến.',
    to: '/lai-lo',
    accent: '#818CF8',
  },
  {
    icon: 'ri-percent-line',
    title: 'Máy tính Chi phí Spread',
    desc: 'Tính chi phí Spread của giao dịch.',
    to: '/doi-chieu',
    accent: '#8B5CF6',
  },
  {
    icon: 'ri-shield-line',
    title: 'Máy tính Rủi ro',
    desc: 'Tính số tiền có thể chịu rủi ro dựa trên tài khoản và tỷ lệ rủi ro.',
    to: '/rui-ro',
    accent: '#A78BFA',
  },
];

export const BROKERS = [
  {
    name: 'IC Markets',
    initial: 'IC',
    platform: 'MetaTrader 4 / 5 · cTrader',
    spread: 'từ 0.0 pip',
    leverage: '1:500',
    regulation: 'ASIC · CySEC · SCB',
    color: '#7C3AED',
  },
  {
    name: 'FxPro',
    initial: 'FP',
    platform: 'MetaTrader 4/5 · cTrader',
    spread: 'từ 0.0 pip',
    leverage: '1:500',
    regulation: 'FCA · CySEC · FSCA',
    color: '#818CF8',
  },
  {
    name: 'XM',
    initial: 'XM',
    platform: 'MetaTrader 4 / 5',
    spread: 'từ 0.6 pip',
    leverage: '1:1000',
    regulation: 'ASIC · CySEC · FSC',
    color: '#8B5CF6',
  },
];